import { ReactElement } from "react";
import { NFTSTUDIOS_URI } from "../../constants/config";
import CompanySign from "../../components/CompanySign";
import website_logo from "../../assets/images/Footer/logo_website.png";
import nftstudios_logo from "../../assets/images/CompanySign/nftstudios-logo.png";
import SocialMedia from "../../components/SocialMedia";
import HorizontalLine from "./components/HorizontalLine";
import styles from "./Footer.module.scss";
import { HOME } from "../../constants/routes";

const Footer = (): ReactElement => {
  const fullYear = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className={styles.footerBody}>
        <div className={styles.footerLine}>
          <a href={HOME}>
            <img
              src={website_logo}
              className={styles.footerLogo}
              height="52"
              alt="Voxel Architects logo"
            />
          </a>

          <SocialMedia />
        </div>
        <HorizontalLine />
        <div className={styles.footerLine}>
          <p>©{fullYear} VoxelArchitects. All rights reserved.</p>
          <p>
            <a
              href="/privacy-policy.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </p>
          <CompanySign
            name="NftStudios"
            url={NFTSTUDIOS_URI}
            logo={nftstudios_logo}
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
